import React, { FunctionComponent } from 'react';
import styles from './carusel-image-slider.module.scss';

export interface ICarouselImageProps {
  src: string;
}

export const CarouselImage: FunctionComponent<ICarouselImageProps> = props => {
  const { src } = props;

  return (
    <img src={src} alt="One of the sliders" className={styles.sliderImage} />
  );
};
